<template>
  <div id="content" v-if="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <a @click="$router.go(-1)" class="btn btn_back" v-translate>Seznam</a>
        </p>
        <p class="buttons">
          <a v-if="$_updateActionAllowed"
             class="btn btn_action btn_delete"
             :title="'Smazat' | translate"
             @click.prevent.stop="deleteEntity"
             v-translate>Smazat</a>
        </p>
        <h1>{{entity.hostname}}</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section>
            <div class="left">
              <detail-entity-info
                  :entity="entity"
              >
              </detail-entity-info>
            </div>
            <div class="right">
            <div class="field_left">
              <date-picker edit-time
                           id="time_start"
                           date-format="d. m. yy"
                           attrKey="start"
                           v-model="entity.start"
                           @update-date="updateDate"
                           :disabled="!isEditable"
              >
                <translate class="translate">Údržba od *</translate>
              </date-picker>
            </div>
            <div class="field_right">
              <date-picker edit-time
                           id="time_end"
                           date-format="d. m. yy"
                           attrKey="end"
                           v-model="entity.end"
                           @update-date="updateDate"
                           :disabled="!isEditable"
              >
                <translate class="translate">Údržba do *</translate>
              </date-picker>
            </div>
              <div class="field_left">
                <text-input
                    id="description"
                    v-model="entity.description"
                    :disabled="!isEditable"
                >
                  <translate class="translate">Poznámka</translate>
                </text-input>
              </div>
            </div>
          </section>
          <section class="buttons" v-if="$_updateActionAllowed">
            <p>
              <a @click="$router.go(-1)" class="btn btn_back btn_seznam" v-translate>Seznam</a>
              <input type="submit" :value="'Uložit' | translate"
                     :class="['btn']"
                     @click.prevent.stop="submitForm">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import detailActions from "@/components/mixins/detail-actions"
import contentSourceMaintenanceWindow from "./mixins/contentSourceMaintenanceWindow"

export default {
  name: "ContentSourceMaintenanceWindowDetail",
  mixins: [
    contentSourceMaintenanceWindow,
    detailActions,
  ],
  data() {
    return {
      selectedContentSources: {},
      moduleName: 'contentSourceMaintenanceWindows',
      entityName: 'content_source_maintenance_window',
      entity: {
        id_content_sources: [],
        start: null,
        end: null,
        description: ""
      },
      datetimeFields: [
        'start',
        'end',
      ],
      updateFields: [
          'start',
          'end',
          'description'
      ],
    }
  },
  created(ContentSourceMaintenanceWindowService) {
    this.entityService = ContentSourceMaintenanceWindowService;

    this.createdInit();
  },
  computed: {
    isEditable(){
      return this.$_updateActionAllowed;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/contentSourceMaintenanceWindow/ContentSourceMaintenanceWindowDetail.vue